import moment from 'moment';
import AppConfig from '../../config';

/* represents a value stored by user preference, it can be any one of string, object, array, null */
export type PreferenceValue = Record<string, unknown> | string | null | Array<unknown> | number;

/**
 * @static
 * @class UserPreference
 * stores user preferences in localStorage
 */
export default class UserPreference {
  /**
   * get preference form storage
   * @param {string} key key to get the preference
   * @returns {PreferenceValue}
   */
  static get(key: string): PreferenceValue {
    const value = window.localStorage.getItem(`${AppConfig.preferenceKey}.${key}`);
    const expiresAt = window.localStorage.getItem(`${AppConfig.preferenceKey}.${key}.expiresAt`);
    if (expiresAt && moment().isAfter(expiresAt)) {
      UserPreference.remove(key);
      return null;
    }
    try {
      if (value) {
        return JSON.parse(value);
      }
      return null;
    } catch (e) {
      return null;
    }
  }

  /**
   * set preference to storage
   * @param {string} key key to get the preference
   * @param {PreferenceValue} value key to get the preference
   */
  static set(key: string, value: PreferenceValue, expiresAt?: string): void {
    window.localStorage.setItem(`${AppConfig.preferenceKey}.${key}`, JSON.stringify(value));
    if (expiresAt) {
      window.localStorage.setItem(`${AppConfig.preferenceKey}.${key}.expiresAt`, expiresAt);
    }
  }

  /**
   * remove a preference from storage
   * @param {string} key key to get the preference
   */
  static remove(key: string): void {
    window.localStorage.removeItem(`${AppConfig.preferenceKey}.${key}`);
    window.localStorage.removeItem(`${AppConfig.preferenceKey}.${key}.expiresAt`);
  }

  /**
   * clear all preferences
   */
  static clear(): void {
    Object.keys(window.localStorage).forEach((key) => {
      if (key.startsWith(AppConfig.preferenceKey)) {
        window.localStorage.removeItem(key);
      }
    });
  }
}
